import { SectionTitle } from "../components/SectionTitle";
import {
  ContentArea,
  InPersonSessionImage,
  IntroArea,
  IntroTextContainer,
  SessionImageContainer,
  SessionPageContainer,
  SubTitle,
} from "../components/SessionPageComponents";
import styled from "styled-components";
import Alluring from "../assets/gallery/Alluring.jpeg";
import LegsForDays from "../assets/gallery/LegsForDays.jpeg";
import Dungeon from "../assets/gallery/dungeon2.png";
import { TextContainer } from "../sections/ContactSection";
import LoyalFansWidget from "../components/LFWidget";
import { Helmet } from "react-helmet";
import { useEffect } from "react";

export const LondonPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Maya Mistress | London Tour | Experienced Redhead Brazilian Dominatrix
        </title>
        <meta
          name="description"
          content="Brazilian Dominatrix based in Amsterdam visits London for the first time. Independent Professional Dominatrix based in Amsterdam. Power Dynamics Specialist. Sensual and Sadistic. Artist of Pleasure and Pain."
        />
        <meta
          name="keywords"
          content="Dominatrix London, Dominatrix England, Mistress London, Brazilian Dominatrix London, London Dominas, London Domina"
        />
        <link rel="canonical" href="https://mayamistress.nl" />
      </Helmet>

      <SessionPageContainer>
        <ContentArea>
          <SectionTitle title="London" />
          <SubTitle>23 - 28 April 2025</SubTitle>
          <br />
          <IntroArea invertOrderOnMobile>
            <IntroTextContainer>
              Hello London,
              <br />
              <br />
              For the very first time I'll be travelling to you, and I'm so
              excited to meet you. I'm a Brazilian Dominatrix with 7 years of
              experience, based in Amsterdam, where I've been for the last 5
              years. My journey began in the Academia, where I wrote my Thesis
              about Power Dynamics. Back then, it was completely - or almost
              completely - unrelated to sexuality. But not much long after my
              graduation, I had the break through to try out the power of FemDom
              - and I was transformed ever since.
              <br />
              <br />
              Today, I take pride and pleasure to offer such liberating
              experiences to others - and to myself - in a professional basis.
              Being a Dominatrix is in my true nature, and I embrace and
              celebrate this fact. And I have my best sessions with submissives
              who strive to have a healthy and proud relationship with their
              kinks and fetishes as well.
              <br />
              <br />I welcome consenting adults of all genders and backgrounds.
              Couples are also more than welcome, however please note that
              different Tributes apply according to what you look for.
            </IntroTextContainer>

            <SessionImageContainer>
              <InPersonSessionImage image={Alluring} />
            </SessionImageContainer>
          </IntroArea>
          <br />
          <br />
          <SubTitle>My Domination Style</SubTitle>
          <IntroArea>
            <SessionImageContainer>
              <InPersonSessionImage image={LegsForDays} />
            </SessionImageContainer>
            <IntroTextContainer>
              Power Dynamics is my specialty, and 'special spot' when it comes
              to FemDom. I love to create a slow-motion, hypnotic vibe through
              seduction and and sensuality and gradually amp up intensity. I'm a
              passionate about building the fricction between desire & denial,
              tension & laughter, agony & ecstasy... With precision, care, and a
              lot of kinky lust, I seduce my preys into submission. And once I
              win you over, I will use you like the little play tool I made you
              to be. Getting your total surrender is just the beginning for Me -
              and the end of you.
              <br />
              Here are some examples of techniques I use to achieve that:
              <ul>
                <li>Clear expectations and safewords</li>
                <li>Power Play and Total Power Exchange</li>
                <li>Gorgeous outfits in leather, latex and high heels</li>
                <li>Bondage, specially using rope</li>
                <li>A mix of soft touches with hard core spanking</li>
                <li>Dirty talk, humiliation and mindfucks</li>
                <li>Pure, primal, unfiltered Sadism</li>
                <li>A touch of Female Supremacy</li>
                <li>Worship, devotion and surrender to Me</li>
                <li>Play with My glorious, gorgeous, sensitive Feet</li>
              </ul>
              <br />
              <br />
            </IntroTextContainer>
          </IntroArea>

          <IntroArea invertOrderOnMobile>
            <IntroTextContainer>
              <SubTitle>The Dungeon</SubTitle>
              <br />I will be having the pleasure to host you at the London
              Dungeon Suite, in London Central. We will have 3 different very
              special rooms to choose from, hundreads of BDSM equipment,
              furniture and items.
              <br />
              <br />
              The use of the dungeon is included in the Tribute. Special fees
              might apply for the use of special items like latex, fuck machine
              and others.
              <br />
              <br />
            </IntroTextContainer>

            <SessionImageContainer>
              <InPersonSessionImageSmall image={Dungeon} />
            </SessionImageContainer>
          </IntroArea>
          <br />
          <br />

          <SubTitle>Don't want to wait?</SubTitle>
          <TextContainer>
            <div style={{ margin: "0 auto", textAlign: "center" }}>
              We can connect right now via Loyal Fans
              <br />
              <br />
              <LoyalFansWidget />
            </div>
          </TextContainer>
        </ContentArea>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </SessionPageContainer>
    </>
  );
};

const InPersonSessionImageSmall = styled.div`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 50vh;
  margin-top: 2rem;
`;
